<template>
  <div class="btn-full-bg line-liff-detail liff-line-font-size-18" v-html="title" @click="clickBtn()"></div>
</template>
<script>
export default {
    name: 'ButtonFullBackground',
    props: {
        title: String
    },
    methods: {
        clickBtn: function () {
            this.$emit('clickButton')
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/color.scss";
.btn-full-bg {
  border-radius: 5px;
  padding: 8px 20px;
  text-align: center;
  width: 100%;
  background: $base-orange;
  border: 2px solid $base-orange;
  color: #fff;
  //letter-spacing: 1.1px;
}
</style>
